<template>
    <div class="p-0 d-flex h-100 w-100">
        <received-files-sidebar></received-files-sidebar>
        <div class="d-flex flex-column h-100 w-100">
            <received-files-header></received-files-header>
            <!--<received-files-main :receivedFiles="file.received"></received-files-main>-->
            <transition name="slideup" mode="out-in">
                <router-view :key="$route.fullPath"></router-view>
            </transition>
        </div>
    </div>
</template>
<script>
import ReceivedFilesMain from './received-files-main'
import ReceivedFilesSidebar from './received-files-sidebar'
import ReceivedFilesHeader from './received-files-header'
import { mapState } from 'vuex'

export default {
    components: {
        ReceivedFilesMain,
        ReceivedFilesSidebar,
        ReceivedFilesHeader
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/received-files-view/received-files-inbox.vue